class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.submenuList = this.querySelector("[data-submenu]");
    this.submenuStack = [];

    this.addEventListener("keyup", this.onKeyUp);
    document.addEventListener("click", this.onFocusOut.bind(this));

    if (this.submenuList) {
      this.submenuList.addEventListener(
        "click",
        this.onSubmenuClick.bind(this),
      );
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    if (
      openDetailsElement === this.mainDetailsToggle &&
      this.submenuStack.length
    ) {
      this.closeSubmenuLevel();
      return;
    }

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    this.resetSubmenu();
    summaryElement.focus();
  }

  onFocusOut(e) {
    const withBoundaries = e.composedPath().includes(this.mainDetailsToggle);

    if (!withBoundaries) {
      this.mainDetailsToggle.removeAttribute("open");
      this.resetSubmenu();
    }
  }

  onSubmenuClick(event) {
    const swapLink = event.target.closest("[data-submenu-swap]");

    if (swapLink) {
      event.preventDefault();
      this.openSubmenuLevel(swapLink);
      return;
    }

    const backLink = event.target.closest("[data-submenu-back]");

    if (backLink) {
      event.preventDefault();
      this.closeSubmenuLevel();
    }
  }

  openSubmenuLevel(swapLink) {
    const template = this.querySelector(
      'template[data-submenu-template="' + swapLink.dataset.submenuSwap + '"]',
    );

    if (!template) return;

    this.submenuStack.push({
      content: this.submenuList.innerHTML,
      swapValue: swapLink.dataset.submenuSwap,
    });
    this.submenuList.innerHTML = template.innerHTML;

    const backLink = this.submenuList.querySelector("[data-submenu-back]");

    if (backLink) backLink.focus();
  }

  closeSubmenuLevel(focusSwapLink = true) {
    const previousLevel = this.submenuStack.pop();

    if (!previousLevel) return;

    this.submenuList.innerHTML = previousLevel.content;

    const swapLink = this.submenuList.querySelector(
      '[data-submenu-swap="' + previousLevel.swapValue + '"]',
    );

    if (swapLink && focusSwapLink) {
      swapLink.focus();
    }
  }

  resetSubmenu() {
    while (this.submenuStack.length) {
      this.closeSubmenuLevel(false);
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.resetSubmenu();
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

